export default class QuoteHandset {
  constructor({
    handsetID = 0,
    model = null,
    description = null,
    dealerEx = 0.0,
    rrpEx = 0.0,
    hardwareCategoryID = 0,
    manufacturerDetailsID = 0,
    quantity = 0,
    itemCost = 0,
    notes = null,
  } = {}) {
    this.handsetID = handsetID;
    this.model = model;
    this.description = description;
    this.dealerEx = dealerEx;
    this.rrpEx = rrpEx;
    this.hardwareCategoryID = hardwareCategoryID;
    this.manufacturerDetailsID = manufacturerDetailsID;
    this.quantity = quantity;
    this.itemCost = itemCost;
    this.notes = notes;
  }
}
